import { Component, inject, OnInit } from '@angular/core';
import { GalleryConfig, GalleryItem, NgxSimpleGalleryComponent, SimpleGalleryDirective } from 'ngx-simple-gallery';
import { DojoBeforeAfterComponent } from './dojo-before-after/dojo-before-after.component';
import { SeoService } from '../core/service/seo.service';
import { GalleryService } from './gallery.service';

@Component({
  selector: 'app-gallery',
  imports: [NgxSimpleGalleryComponent, SimpleGalleryDirective, DojoBeforeAfterComponent],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.css',
})
export class GalleryComponent implements OnInit {
  public dojoItems: GalleryItem[];
  public everydayItems: GalleryItem[];
  public ajpBern202409Items: GalleryItem[];
  public zao202410Items: GalleryItem[];
  public graduation2024Q4: GalleryItem[];

  public dojoGalleryConfig: GalleryConfig = {
    showModalThumbnailList: false,
  };

  private readonly galleryService = inject(GalleryService);
  private readonly seoService = inject(SeoService);

  public constructor() {
    this.dojoItems = this.galleryService.getDojoItems();
    this.everydayItems = this.galleryService.getEveryDayItems();
    this.ajpBern202409Items = this.galleryService.getAjpBern202409Items();
    this.zao202410Items = this.galleryService.getZao202410Items();
    this.graduation2024Q4 = this.galleryService.getGraduation2024Q4Items();
  }

  public ngOnInit(): void {
    this.seoService.updateMetaTag(
      'description',
      'Trainieren Sie Kampfsport in unserem Studio. Sehen Sie sich unsere Bilder an und erfahren ' +
        'Sie mehr über unser Trainingsangebot und unsere Räumlichkeiten.',
    );

    this.seoService.createLinkForCanonicalURL('/gallery');
  }
}
